export default __webpack_public_path__ + "static/shield-brown-01-73a5f58bde79a894f758d7f598b08dde.svg";